import {Injectable} from '@angular/core';
import {Configurator, ConfiguratorCommonsService} from '@spartacus/product-configurator/rulebased';
import {ConfiguratorAttributeCompositionContext} from '@spartacus/product-configurator/rulebased/components/attribute/composition/configurator-attribute-composition.model';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ALLOWED_ADDON_ATTRIBUTES, getAddonGroup} from '../utils';
import Attribute = Configurator.Attribute;

@Injectable({
  providedIn: 'root',
})
export class ConfiguratorAddonService {
  constructor(private configuratorCommonsService: ConfiguratorCommonsService) {}

  getFilteredAddonAttributes(
    attributeComponentContext: ConfiguratorAttributeCompositionContext,
  ): Observable<Attribute[]> {
    return this.configuratorCommonsService.getConfiguration(attributeComponentContext.owner).pipe(
      map((configuration) => {
        const addonGroup = getAddonGroup(configuration, attributeComponentContext.attribute.name);
        const filtered = addonGroup?.attributes?.filter((attribute) =>
          ALLOWED_ADDON_ATTRIBUTES.find((attr) => attr === attribute.name),
        );
        const addonAttributes = [];
        // We need to create a copy because Attributes are not extensible
        if (filtered?.length) {
          for (const attribute of filtered) {
            addonAttributes.push(
              Object.assign(
                {},
                {
                  ...attribute,
                  addonName: attributeComponentContext.attribute.name,
                },
              ),
            );
          }
        }
        return addonAttributes;
      }),
    );
  }
}
